import '@dabble/quillui/global';
import '@fontsource/pt-serif';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import App from './App.vue';
import { captureAttribution, externalReferrerHost, readLandingNote, syncTouchesToServer } from './lib/attribution';
import './lib/firebase';
import router from './router';
import './styles/global.css';

// Read the landing now (the router may rewrite the URL), store it once consent allows.
// twig-consent.js asks EU/UK visitors first; without it, store straight away as before.
const landing = {
  search: location.search,
  referrer: document.referrer,
  path: location.pathname,
  at: Date.now(),
};
const storeAttribution = () => {
  // Arrived from twig.io: its forwarder left a note of the real referrer
  const note = externalReferrerHost(landing.referrer) ? null : readLandingNote();
  captureAttribution(
    landing.search,
    undefined,
    landing.at,
    note?.referrer ?? landing.referrer,
    note?.landingPath || landing.path
  );
  syncTouchesToServer();
};
const consent = (window as Window & { twigConsent?: { whenAllowed(fn: () => void): void } }).twigConsent;
if (consent) consent.whenAllowed(storeAttribution);
else storeAttribution();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.mount('#app');
